import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const duffel = defineConnector({
  identifier: "duffel",
  name: "Duffel",
  tagLine: "Flight and stay booking API",
  logo,
  protocol: "http",
  tags: ["productivity", "travel"],
  defaultUrlPattern: () => "https://api\\.duffel\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Duffel dashboard](https://app.duffel.com/), open **Developers › Access tokens** and create a live or test token.",
        },
      ],
    },
    {
      title: "Paste your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          placeholder: "duffel_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.duffel.com/air/airlines?limit=1",
      headers: { "Duffel-Version": "v2" },
    }),
  },
});
